const PLAYER_NAME_PLACEHOLDER = /\[nom du joueur\]/gi;

export function personalizeQuestIntro(intro, playerName = "") {
  if (!intro) return "";
  const displayName = String(playerName || "").trim() || "lecteur";
  return intro.replace(PLAYER_NAME_PLACEHOLDER, displayName);
}

export function formatQuestNumericDate(dateString) {
  if (!dateString) return "";
  const [year, month, day] = String(dateString).split("-");
  if (!year || !month || !day) return dateString;
  return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
}

export function formatQuestJournalDate(dateString) {
  if (!dateString) return "";

  const [year, month, day] = dateString.split("-").map(Number);
  if (!year || !month || !day) return dateString;

  const date = new Date(year, month - 1, day);
  if (Number.isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
